import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { WebrtcDeviceViewComponent } from 'libs/vaelsys-webrtc-lib';
import { GlobalMethodsService } from '../../../../../services/global-methods.service';

@Component({
  selector: 'app-video-generic-modal',
  templateUrl: './video-generic-modal.component.html',
  styleUrls: ['./video-generic-modal.component.scss'],
})
export class VideoGenericModalComponent implements OnInit {

  @Input('webRtcView') webRtcView: WebrtcDeviceViewComponent;
  @Input('portrait') portrait: boolean;

  constructor(
    private modalCtrl: ModalController,
    public gms: GlobalMethodsService) { }

  ngOnInit() {}

  dismiss(value) {
    this.modalCtrl.dismiss({ confirm: value });
  }
}
